
jQuery(document).ready( function($){

	var adsManager = function( container )
	{
		$('.date-picker', container ).pickadate({
            formatSubmit: 'dd-mm-yyyy'
        });
	};

	if( $('.edit.advert').length ) {
		new adsManager( $('.edit.advert') );
	}

});
